import React from 'react';

import { useTranslation } from '@ibe/components';
import fallback from '../../../../Translations/generated/Checkout.de.json';
import Keys from '../../../../Translations/generated/Checkout.de.json.keys';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { useAffiliateContext } from '../../../../Util/AffiliateProvider';
import { sanitize } from '@ibe/services';

const HotLine = () => {
  const { t } = useTranslation('Checkout', fallback);
  const affiliateContactData = useAffiliateContext().metaContent?.content?.contactData;
  return affiliateContactData ? (
    <aside>
      <div
        className="sticky-summary-box-hotline"
        dangerouslySetInnerHTML={{ __html: sanitize(affiliateContactData + '') }}
      ></div>
    </aside>
  ) : (
    <aside className="sticky-summary-box-hotline" aria-label={t(Keys.consulting)}>
      <h3>{t(Keys.consulting)}</h3>
      <div>
        <FontAwesomeIcon icon={faPhone} />
        <span>{t(Keys.hotlineNumber)}</span>
      </div>
      <p>{t(Keys.officeHours)}</p>
    </aside>
  );
};

export default HotLine;
